import { compile } from "@intlify/core-base";
import type { MessageCompiler } from "vue-i18n";

/** Compile translations while treating API labels and malformed messages as plain text. */
export const safeMessageCompiler: MessageCompiler = (message, context) => {
  if (typeof message !== "string") {
    return compile(message, context);
  }

  const literal = () => message;
  // Identity translations and fallback keys are API labels, including valid-looking
  // syntax such as "Voice | Video" or "Service {region}".
  // The default parser silently drops a trailing opening brace (with optional
  // whitespace), so this malformed case cannot be caught through onError.
  if (message === context.key || /\{\s*$/.test(message)) {
    return literal;
  }

  try {
    return compile(message, {
      ...context,
      // vue-i18n normally reports parse errors through a callback instead of throwing.
      onError(error) { throw error; },
    });
  } catch (error) {
    if (error instanceof SyntaxError) {
      return literal;
    }
    throw error;
  }
};
